import styled from 'styled-components'
import React, { useContext } from 'react'

import AppContext from '../context/appContext'

const GenericBackgroundLayer = styled.div`
  width: ${(props) => (props.width ? props.width : '100%')};
  display: flex;
  flex-direction: ${(props) => (props.fDir ? props.fDir : 'row')};
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: ${(props) => (props.align ? props.align : 'center')};
  min-height: 100vh;
  /* max-height: 100vh; */
  box-sizing: border-box;

  &.player {
    @media only screen and (max-device-width: 1000px) and (orientation: landscape) {
      max-height: 100vh;
    }
  }

  &.login-mode {
    z-index: 5;
    padding-bottom: 0;
    height: 100vh;
  }

  &.mainpage {
    display: block;
  }

  &.light {
    background: white;

    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(248, 12, 185, 0) 37%,
      rgba(120, 23, 154, 0.23) 69%,
      rgba(52, 33, 82, 0) 92%,
      rgba(255, 255, 255, 1) 100%
    );
  }

  &.standard {
    background: rgb(52, 33, 82);
    background: linear-gradient(
      0deg,
      rgba(52, 33, 82, 1) 0%,
      rgba(52, 33, 82, 1) 37%,
      rgba(120, 23, 154, 0.9724264705882353) 69%,
      rgba(52, 33, 82, 1) 92%,
      rgba(52, 33, 82, 1) 100%
    );
  }

  &.select-subscription-screen,
  &.chose-ver {
    overflow: auto;
    padding-bottom: 5%;
  }

  @media only screen and (max-width: 600px) {
    /* padding-bottom: 25%; */
    &.diet-meal-details {
      padding-bottom: 25%;
    }

    &.plan-screen,
    &.challenge-main-screen,
    &.mainpage,
    &.album-screen,
    &.settings {
      padding-bottom: 25%;
      padding-top: 0%;
    }

    &.diet-screen {
      padding-bottom: 35%;
      padding-top: 0%;
      margin-bottom: 10%;
    }

    &.select-subscription-screen {
      padding-bottom: 0;
      align-items: flex-start;
      overflow: auto;
      padding-bottom: 10%;
    }
  }

  @media (min-width: 1024px) and (max-width: 1280px) {
    &.progress-screen,
    &.diet-screen,
    &.user-profile,
    &.settings {
      padding-bottom: 10%;
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    &.progress-screen,
    &.diet-screen,
    &.user-profile,
    &.settings {
      padding-bottom: 10%;
    }
  }

  @media (min-width: 1024px) and (max-width: 1280px) {
    &.mainpage {
      padding-bottom: 10%;
      padding-top: 0%;
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    &.mainpage {
      padding-bottom: 10%;
      padding-top: 0%;
    }
  }
`

export default GenericBackgroundLayer
